// 全局颜色配置
const el = document.documentElement
//主题色
el.style.setProperty('--el-color-primary', '#20D3B3')
//输入框
el.style.setProperty('--el-input-border-color', '#20D3B3')
//按钮
el.style.setProperty('--el-button-hover-bg-color', 'rgb(99, 224, 202)')
el.style.setProperty('--el-button-hover-border-color', 'rgb(99, 224, 202)')
el.style.setProperty('--el-button-active-bg-color', 'rgb(30, 173, 147)')
el.style.setProperty('--el-button-active-border-color', 'rgb(30, 173, 147)')
